const configuration =
  process.env.NODE_CONFIG && JSON.parse(process.env.NODE_CONFIG);

const env = process.env.NODE_CONFIG_ENV;

const applicationId = process.env.APPLICATION;

const config: Config = configuration ?? {};

console.log(
  `[GW_CONFIG] Application "${applicationId}" loaded with configuration for "${env}" environment`,
);

export default config;

export type GeocomplyEnv =
  | { type: 'devStack'; name: string }
  | { type: 'prod' | 'cert' | 'qa' | 'staging' };

export type Config = {
  env: string;
  baseURL: string;
  clientID: string;
  unifiedModules?: {
    clientId: string;
    env: {
      type: string;
    };
    customConfig?: {
      api: string;
      web: string;
    };
  };
  loginURL: string;
  realityCheck: string;
  termsAndConditionsUrl: string;
  casinoWebUrl: string;
  domain: string;
  game: {
    playMode: string;
    renderMode: string;
    currency: string;
    lang: string;
    countryCode: string;
    providers: {
      RGS: {
        url: Record<string, string>;
        host: Record<string, string>;
      };
    };
    brandTheme: string;
  };
  accountAndWalletApi: {
    endpoints: {
      SESSION_RENEW: string;
      CURRENT_SESSION: string;
      USER_DETAILS: string;
      USER_BALANCE: string;
      USER_FREE_BETS: string;
    };
  };
  fabric: {
    endpoints: {
      trendingGames: {
        addGame: string;
      };
      customerData: {
        package: string;
        features: string;
        preferences: string;
      };
      userContext: {
        accountSettings: string;
      };
      aggregation: {
        aggregation: string;
        serverTime: string;
      };
      userActivity: {
        recentlyPlayedGames: string;
      };
    };
  };
  geolocation: {
    env: string;
    installerKey: string;
    clientAuthToken: string;
    serviceName: string;
    country: string;
  };
  geoComply: {
    product: string;
    license: {
      expirationGraceInSeconds: number;
      expirationInSeconds: number;
    };
    plc: {
      version: string;
      installerKey: string;
    };
    endPoints: {
      license: string;
      verify: string;
      connectionInfo: string;
    };
    help: string;
    supportNDBS?: string;
  };
  cpp: {
    brandCode: string;
    platformCode: {
      ios: string;
      android: string;
      mobile: string;
      desktop: string;
    };
  };
  rum: {
    applicationId: string;
    clientToken: string;
    site: string;
    service: string;
    sampleRate: number;
    trackInteractions: boolean;
    trackResources: boolean;
    trackLongTasks: boolean;
  };
  incentiveGamesApi: {
    baseUrl: string;
    huffAndPuffBaseUrl?: string;
  };
  gameWindowData: {
    baseUrl?: string;
    endpoints: {
      gameWindow: string;
      game: string;
    };
  };
  prismic: {
    endPoints: {
      GAME_WINDOW: string;
    };
  };
  gaCode: string;
  gtmAuth: {
    id: string;
  };

  amplitude: {
    apiKey: string;
  };
  snowplow?: {
    appId: string;
    androidAppId: string;
    trackerUrl: string;
  };
  gcmLib?: Record<
    string,
    {
      stage: string;
      prod: string;
    }
  >;
  defaultRegion: string;
  glsEndpoint: string;
  lobbyRedirectUrl?: string;
  GLS?: {
    GLSBaseUrl: Record<string, string>;
    GLSPath: string;
  };
  mdsEndpoint: Record<string, string>;
  locationAppAndroid: string;
  geocomplyEnv?: GeocomplyEnv;
};
